import { RootState } from '@/stores/store';

export const getUserInfoState = (state: RootState) => state.user;
